import { AgreementReadinessErrorCode, CampaignsApiException } from '@urbanx/agx.campaigns.client';

const messages: Record<AgreementReadinessErrorCode, string> = {
  DraftSelectionRequired: 'Choose a saved Listing Proposal draft to review.',
  FormNotFound:
    'The selected draft is no longer available. Review without this selection or choose another draft.',
  InvalidFormType:
    'The selected form is not a Listing Proposal draft. Review without this selection or choose another draft.',
  UnsupportedState: 'Agreement readiness is not available for this state.',
  CampaignIneligible: 'This campaign cannot be reviewed for an agreement.',
  AlreadyConverted: 'An agreement already exists for this campaign. This review did not create it.',
  FeatureDisabled: 'Agreement readiness is currently unavailable.',
  AccessDenied: 'Agreement readiness is unavailable for this campaign.',
  CampaignNotFound: 'Agreement readiness is unavailable for this campaign.',
};

export const classifyReadinessError = (error: unknown) => {
  if (
    typeof error === 'object' &&
    error !== null &&
    'code' in error &&
    'message' in error &&
    typeof error.message === 'string'
  ) {
    const code = Object.values(AgreementReadinessErrorCode).find((code) => code === error.code);
    if (code) return { code, message: messages[code], retry: false };
  }
  if (typeof error === 'string')
    return {
      // Declared error responses can throw an empty body without retaining HTTP status.
      message: error
        ? 'The readiness request is invalid. Close the review and try again.'
        : 'Agreement readiness is unavailable for this campaign.',
      retry: false,
    };
  if (error instanceof CampaignsApiException) {
    if (error.status === 401)
      return {
        message: 'Your session could not be verified. Sign in again to continue.',
        retry: false,
      };
    if (error.status === 403)
      return { message: 'Agreement readiness is unavailable for this campaign.', retry: false };
    if (error.status === 400)
      return {
        message: 'The readiness request is invalid. Close the review and try again.',
        retry: false,
      };
  }
  return { message: 'Unable to load agreement readiness. Please retry.', retry: true };
};
